import { useTranslation } from "react-i18next";
import { Label } from "../../forms/Label/Label";
import { Select, TSelectOption } from "../../forms/Select";

type TDateTypeDropdownProps = {
  selVal?: string;
  onDateTypeSel: (value: string) => void;
  includeCallDateOnly?: boolean;
};

const DateTypeDropdown = ({
  selVal,
  onDateTypeSel,
  includeCallDateOnly = false,
}: TDateTypeDropdownProps) => {
  const { t } = useTranslation(["common"]);

  const dateTypeMenuItems = includeCallDateOnly
    ? [
        { value: "employee_termination", label: "Termination Date" },
        { value: "leave_begin", label: "Leave Start" },
        { value: "leave_return", label: "Leave Expected Return" },
      ]
    : [
        { value: "call_date", label: "By Call Date" },
        { value: "audit_date", label: "By Audit Date" },
      ];

  return (
    <>
      <Label weight={"medium"} htmlFor="date_type" className="mb-1">
        {t("FILTER.DATE_TYPE")}
      </Label>
      <Select
        name="date_type"
        options={dateTypeMenuItems}
        value={dateTypeMenuItems?.find((item) => item.value === selVal) ?? null}
        onChange={(option: TSelectOption | null) =>
          onDateTypeSel(option?.value ?? "")
        }
        getOptionLabel={(option: TSelectOption) => option.label}
        getOptionValue={(option: TSelectOption) => option.value}
        placeholder={t("FILTER.DATE_TYPE")}
        className="text-sm"
        isClearable={false}
      />
    </>
  );
};

export default DateTypeDropdown;
